var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',[_c('router-link',{attrs:{"to":"/about"},nativeOn:{"click":function($event){return _vm.$emit('open')}}},[_vm._v("Who We Are")]),_vm._v(" "),_c('router-link',{attrs:{"to":"/contact"},nativeOn:{"click":function($event){return _vm.$emit('open')}}},[_vm._v("Get In Touch")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }